module.exports = __webpack_public_path__ + "static/media/code10.f909edd9.png";